"use strict";
/**
 * Shared AI Use Case domain types and helpers.
 *
 * Mirrors the portal's `Deliver/ai-core` module so the library can stay
 * independent of any host-application module layout. Hosts that already
 * normalise use cases on their side can simply pass instances of
 * `WsDeliverAiUseCase` to library components.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUseCaseStage = exports.normalizeAiUseCase = void 0;
var normalizeFields = function (fields) {
    return Object.keys(fields || {}).reduce(function (result, key) {
        var value = fields ? fields[key] : undefined;
        if (value !== null && value !== undefined) {
            result[key] = value;
        }
        return result;
    }, {});
};
/**
 * Adapt an API record to the library model, keeping the original
 * `title`, `description`, `workflow`, and `systemInformation` properties.
 */
exports.normalizeAiUseCase = function (useCase) {
    var normalized = {
        id: "" + (useCase.id != null ? useCase.id : ""),
        title: "" + (useCase.title || ""),
        fields: normalizeFields(useCase.fields),
    };
    if (useCase.description) {
        normalized.description = "" + useCase.description;
    }
    if (useCase.workflow) {
        normalized.workflow = "" + useCase.workflow;
    }
    if (useCase.systemInformation) {
        normalized.systemInformation = useCase.systemInformation;
    }
    return normalized;
};
/**
 * Maps known use-case ids to their workflow stage. Defaults to a
 * heuristic for ids that are not explicitly mapped.
 */
exports.getUseCaseStage = function (id) {
    if (id === "4") {
        return 4;
    }
    else if (id === "7") {
        return 4;
    }
    else if (id === "19") {
        return 3;
    }
    else if (id === "31") {
        return 3;
    }
    else if (id === "32") {
        return 3;
    }
    else if (id === "39") {
        return 7;
    }
    else if (id === "41") {
        return 4;
    }
    else if (id === "48") {
        return 3;
    }
    else if (id === "53") {
        return 2;
    }
    else if (id === "60") {
        return 2;
    }
    else if (id === "62") {
        return 6;
    }
    if (id < "50") {
        return 2;
    }
    return 1;
};
